import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {Grid} from '@material-ui/core';

import {AccountDetails, Password} from './components';
import {getProfile} from '../../apis/api';
import CircularProgress from '@material-ui/core/CircularProgress';

const Loading = () => (
    <div style={{display: 'flex', width: '100%', justifyContent: 'center', paddingTop: '20px'}}>
        <CircularProgress />
    </div>
);

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(4)
    }
}));

const Account = () => {
    const classes = useStyles();
    const [userData, setUserData] = useState(null);

    const errorHandler = () => {
        //
    };

    useEffect(() => {
        if (!userData) {
            getProfile()
                .then(({isExist, user}) => {
                    if (!isExist) return errorHandler();

                    setUserData(user);
                }).catch(() => {
                    return errorHandler();
                });
        }
    });

    if (!userData) {
        return <Loading />
    }

    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={4}
            >
                <Grid
                    item
                    lg={4}
                    md={6}
                    xl={4}
                    xs={12}
                >
                    <Password/>
                </Grid>
                <Grid
                    item
                    lg={8}
                    md={6}
                    xl={8}
                    xs={12}
                >
                    <AccountDetails user={userData}/>
                </Grid>
            </Grid>
        </div>
    );
};

export default Account;
